export const PROP_MAP_CONFIG = 'KE_PROP_MAP_CONFIG';
